module.exports = __webpack_public_path__ + "static/img/step_1-button.43814a85.png";